import { Box } from "@mui/material";
import { RichTextSegment } from "JS/Models/Checklist";

export interface ChecklistTextProps {
    segments: RichTextSegment[];
}

export const ChecklistText = (props: ChecklistTextProps) => {
    const { segments } = props;

    return (
        <>
            {segments.map((segment, index) => (
                <Box
                    component="span"
                    key={`${segment.text}-${index}`}
                    sx={{
                        fontWeight: segment.bold ? 700 : undefined,
                        fontStyle: segment.italic ? "italic" : undefined,
                        // The mockup uses pure red; the theme's error colour is the app's
                        // equivalent and clears AA contrast, which #FF0000 does not.
                        color: segment.red ? "error.main" : undefined,
                    }}
                >
                    {segment.text}
                </Box>
            ))}
        </>
    );
};
